// extracted by mini-css-extract-plugin
module.exports = {"globalFilter":"GlobalFilter_globalFilter__3Pjva","input":"GlobalFilter_input__1PpuU","showSearchText":"GlobalFilter_showSearchText__2ayhu"};